import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Siti } from 'src/app/models/siti';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root',
})
export class SitiService {
  private http = inject(HttpClient);
  sitiUrl = environment.ildatoArticoliDpi + 'api/siti';

  private _listSiti = new BehaviorSubject<Siti[] | undefined>(undefined); 

  list(): Observable<Siti[]> {
    return this.http.get<Siti[]>(this.sitiUrl);
  }

  listTemp(forceRefresh: boolean = false): Observable<Siti[]>{
    if(this._listSiti.value == undefined || forceRefresh){
      this.http.get<Siti[]>(this.sitiUrl).subscribe({
        next: res=>{
          this._listSiti.next(res);
        },
        error: err=>{
          if(err?.error?.title){
            notify(err.error.title, "error");
          }
          else{
            notify("Errore recupero lista siti", "error");
          }
        }
      })
    }

    return this._listSiti.asObservable().pipe(filter( r => r!= null));
  }

  get(id: number): Observable<Siti> {
    return this.http.get<Siti>(this.sitiUrl + '/' + id);
  }

  insert(values: Siti): Observable<Siti> {
    return this.http.post<Siti>(this.sitiUrl, values);
  }

  remove(idReparto: number): Observable<Siti> {
    return this.http.delete<Siti>(this.sitiUrl + '/' + idReparto);
  }

  update(key: number, values: Siti): Observable<Siti> {
    return this.http.put<Siti>(this.sitiUrl + '/' + key, values);
  }

  cleanTemp(){
    this._listSiti.next(undefined);
  }
}
